<script lang="ts">
  import { overlayActivity } from '../model';
</script>

<div
  class="bg-default-900/25 fixed z-30 h-full w-full transition-opacity {!$overlayActivity
    ? 'pointer-events-none opacity-0'
    : 'opacity-100'}"
></div>
